import React from 'react';
import './SiteNav.css';

export default function SiteNav({ active, mapHref = '/#/', children }: {
  active: 'map' | 'records'; mapHref?: string; children?: React.ReactNode;
}) {
  return <><nav className="nanahara-nav" aria-label="七原くんの記録">
    <a className="nanahara-nav__brand" href={mapHref}>七原くん</a>
    <a href={mapHref} aria-current={active === 'map' ? 'page' : undefined}>聖地マップ</a>
    <a href="/records/" aria-current={active === 'records' ? 'page' : undefined}>配信ログ</a>
  </nav>{children}</>;
}
